import React, { useMemo } from "react";
import { MessageBanner, Icon, Loading, Headline, } from "@folio/stripes/components";
import { FormattedMessage, FormattedDate, FormattedTime } from "react-intl";
import { TitleImportEventsTable } from "./TitleImportEventsTable";
import styles from "./titleImport.module.css";
var PHASES = ["SCANNING", "RESERVING", "IMPORTING"];
export var TitleImportProgress = function (_a) {
    var progress = _a.progress;
    var bannerType = progress.status === "COMPLETED"
        ? "success"
        : progress.status === "FAILED"
            ? "error"
            : "default";
    var steps = useMemo(function () {
        var currentIndex = PHASES.indexOf(progress.phase);
        return PHASES.map(function (phase, index) {
            var state;
            if (progress.status === "COMPLETED") {
                state = "done";
            }
            else if (index < currentIndex) {
                state = "done";
            }
            else if (index === currentIndex) {
                state = progress.status === "FAILED" ? "error" : "active";
            }
            else {
                state = "pending";
            }
            return { phase: phase, state: state };
        });
    }, [progress.phase, progress.status]);
    return (React.createElement("div", null,
        React.createElement(MessageBanner, { type: bannerType },
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.status.".concat(progress.status) })),
        React.createElement("ol", { className: styles.stepper }, steps.map(function (_a) {
            var phase = _a.phase, state = _a.state;
            return (React.createElement("li", { key: phase, className: styles.step },
                state === "active" ? (React.createElement(Loading, { size: "medium" })) : state === "done" ? (React.createElement(Icon, { icon: "check-circle", status: "success", size: "medium" })) : state === "error" ? (React.createElement(Icon, { icon: "times-circle-solid", status: "error", size: "medium" })) : (React.createElement(Icon, { icon: "clock", size: "medium" })),
                React.createElement(Headline, { size: "small", margin: "none", tag: "div", faded: state === "pending", weight: state === "active" || state === "error" ? "bold" : "regular" },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.phase.".concat(phase) }))));
        })),
        React.createElement("div", { className: styles.progressBarContainer },
            React.createElement("div", { className: styles.progressBarTrack },
                React.createElement("div", { className: progress.status === "FAILED"
                        ? styles.progressBarFillError
                        : styles.progressBarFill, style: { width: "".concat(progress.progressPercent, "%") } })),
            React.createElement("div", { className: styles.progressBarLabel },
                progress.progressPercent,
                "%")),
        React.createElement("div", { className: styles.statsContainer },
            React.createElement("div", { className: styles.statsRow },
                React.createElement("span", null,
                    progress.phaseProcessed,
                    " / ",
                    progress.phaseTotal),
                progress.status === "IN_PROGRESS" &&
                    progress.estimatedCompletionAt && (React.createElement("span", { className: styles.etaLabel },
                    " — ",
                    React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.eta" }),
                    " ",
                    React.createElement(FormattedDate, { value: progress.estimatedCompletionAt }),
                    " ",
                    React.createElement(FormattedTime, { value: progress.estimatedCompletionAt })))),
            React.createElement("div", { className: styles.statsGrid },
                React.createElement("div", { className: styles.statItem },
                    React.createElement("span", { className: styles.statValue }, progress.titlesCreated),
                    React.createElement("span", { className: styles.statLabel },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.stat.titlesCreated" }))),
                React.createElement("div", { className: styles.statItem },
                    React.createElement("span", { className: styles.statValue }, progress.productsCreated),
                    React.createElement("span", { className: styles.statLabel },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.stat.productsCreated" }))),
                React.createElement("div", { className: styles.statItem },
                    React.createElement("span", { className: styles.statValue }, progress.productNumbersCreated),
                    React.createElement("span", { className: styles.statLabel },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.stat.productNumbersCreated" }))),
                React.createElement("div", { className: styles.statItem },
                    React.createElement("span", { className: styles.statValue }, progress.skippedRecords),
                    React.createElement("span", { className: styles.statLabel },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.stat.skippedRecords" }))),
                React.createElement("div", { className: styles.statItem },
                    React.createElement("span", { className: styles.statValue }, progress.errorCount),
                    React.createElement("span", { className: styles.statLabel },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.stat.errorCount" }))),
                React.createElement("div", { className: styles.statItem },
                    React.createElement("span", { className: styles.statValue }, progress.warningCount),
                    React.createElement("span", { className: styles.statLabel },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.stat.warningCount" }))))),
        React.createElement(TitleImportEventsTable, { fileName: progress.fileName, isRunning: progress.status === "IN_PROGRESS", initialErrorCount: progress.errorCount, initialWarningCount: progress.warningCount })));
};
